export default {"src":"/_next/static/media/hourofcode.4470868d.ico","height":16,"width":16,"blurWidth":0,"blurHeight":0};